import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';

import Alert from '../../components/alerts/Alert';

class AlertLoader extends React.Component {
    constructor(props) {
        super(props);
        this.clearAlert = this.clearAlert.bind(this);
    }

    clearAlert(alertId) {
        this.props.actions.clearAlert(alertId);
    }

    render() {
        let alerts = [
            this.props.modules.error,
            this.props.profiles.error,
            this.props.versions.error,
            this.props.projects.error,
            this.props.forms.error,
            this.props.clover.error,
        ];
        alerts = alerts.filter((alert) => { return alert; });
        alerts = alerts.map((e) => { return { message: e, type: 'error' }; });

        alerts = [
            ...alerts,
            ...this.props.alerts.data.filter((alert) => { return alert.type !== 'banner'; }),
        ];
        if (typeof this.props.viewName === 'undefined' || this.props.viewName.length === 0) {
            alerts = alerts.filter((a) => {
                return a.global || this.props.router.location.pathname.indexOf(a.view) > 0;
            });
        } else {
            alerts = alerts.filter((a) => {
                return a.view === this.props.viewName;
            });
        }

        if (alerts.length === 0) {
            return null;
        }
        return (
            <div className="alert-box">
                {alerts.map((alert, index) => {
                    /* eslint-disable */
                    return (
                        <Alert
                            key={index}
                            message={alert.message}
                            alertClass={alert.type}
                            dismissable={alert.dismissable}
                            clearable={alert.clearable}
                            clearAction={alert.clearAction}
                            link={alert.link}
                            linkText={alert.linkText}
                            alertId={alert.id}
                            clearAlert={this.clearAlert}
                        />
                    );
                    /* eslint-enable */
                })}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertLoader);
